/** Colyseus: нормальный выход по leave(true) */
export const LOBBY_CLOSE_CONSENTED = 4000;

const SESSION_PREFIX = 'seka:lobby:';

export function lobbySessionStorageKey(mode) {
  return `${SESSION_PREFIX}${String(mode || 'seka')}`;
}

export function readPersistedLobbyReconnect(mode) {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(lobbySessionStorageKey(mode));
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (o?.reconnectionToken && typeof o.reconnectionToken === 'string') {
      return o.reconnectionToken;
    }
    return null;
  } catch {
    return null;
  }
}

export function writePersistedLobbyReconnect(mode, room) {
  if (typeof sessionStorage === 'undefined' || !room?.reconnectionToken) return;
  try {
    sessionStorage.setItem(
      lobbySessionStorageKey(mode),
      JSON.stringify({
        reconnectionToken: room.reconnectionToken,
        at: Date.now(),
      })
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearPersistedLobbyReconnect(mode) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(lobbySessionStorageKey(mode));
  } catch {
    /* ignore */
  }
}
